import React from 'react'
import styled from 'styled-components'
import { Switch } from '@intelie/ui'

type SwitchProps = {
    description: string
    active: boolean
    disabled: boolean
    help: string
    onChange: () => void
}

export const CustomSwitch: React.FC<SwitchProps> = ({ description, onChange, help, active, disabled }: SwitchProps) => {
    return (
        <SwitchContainer className="form-group">
            <label>{description}</label>
            <Row>
                <Switch disabled={disabled} active={active} onChange={onChange} />
                <span className="help-block">{help}</span>
            </Row>
        </SwitchContainer>
    )
}

const Row = styled.div`
    display: flex;
    flex-direction: row;
`

const SwitchContainer = styled.div`
    display: flex;
    align-content: center;
    flex-direction: column;
`
